
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic05 as ObiHydraulic05Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-05.js';
 
 
 

 
 export const ObiHydraulic05 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-05',
   elementClass: ObiHydraulic05Element,
   events: {
     
   }
  });
 
 